module.exports = "<hybse-admin-list-market [isDemo]=\"true\"></hybse-admin-list-market>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-markets/demo-markets.component.html
// module id = ../../../../../src/app/components/pages/demo-company/demo-markets/demo-markets.component.html
// module chunks = main